import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from "classnames/bind"

import { FluidImage } from "components/shared/fluid-image/FluidImage"
import styles from './../home-page.module.scss';

const cx = classNames.bind(styles)

export const WebCategoryMobile = (props) => {
    const {altText, image, link, title, label, fadeInDirection} = props

    return (
        <div className={cx(["col-12", "animate__animated", "d-md-none", "website-category-mobile"], {
            "animate__fadeInLeft": fadeInDirection === 'left',
            "animate__fadeInRight": fadeInDirection === 'right'
        })}>
            <NavLink
                to={link}
                title={title}
            >
                <FluidImage altText={altText} image={image} />
            </NavLink>
            <h3>
                <NavLink
                    to={link}
                    title={title}
                >
                    {label}
                </NavLink>
            </h3>
        </div>
    )
}